import { App, Button, Space, Tag, Tooltip } from "antd";
import { TableUi } from "../../ui";
import { EditDetailBtn, RemoveDetailBtn, StartBtn } from "../../ui";
import { useDispatch } from "react-redux";
import {
  inventarioInicialSetActive,
  inventarioInicialStartDelete,
  inventarioInicialStartLoad,
  inventarioInicialStartProcess,
  inventarioInicialStartUpdate,
} from "../../../actions";
import { EstadoInventarioInicial } from "../../../types";
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  MinusCircleOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { ShowConfirm, ShowDeleteConfirm } from "../../../helpers";

const columns = (acciones) => {
  const {
    handleEditar,
    handleEliminar,
    handleConfirmar,
    handleProcesarInventarioInicial,
  } = acciones;
  return [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      width: "5%",
      render: (text, record, i) => <>{i + 1}</>,
    },
    {
      title: "Periodo Contable",
      dataIndex: "periodo_nombre",
      key: "periodo_nombre",
      align: "center",
    },
    {
      title: "Almacén",
      dataIndex: "almacen_nombre",
      key: "almacen_nombre",
      align: "center",
    },
    {
      title: "Estado",
      dataIndex: "estado_nombre",
      key: "estado_nombre",
      render: (value, record) => (
        <>
          {record?.estado === EstadoInventarioInicial.BORRADOR && (
            <Tag color="default" icon={<ClockCircleOutlined />}>
              {value}
            </Tag>
          )}
          {record?.estado === EstadoInventarioInicial.CONFIRMADO && (
            <Tag color="processing" icon={<SyncOutlined spin />}>
              {value}
            </Tag>
          )}
          {record?.estado === EstadoInventarioInicial.PROCESADO && (
            <Tag color="success" icon={<CheckCircleOutlined />}>
              {value}
            </Tag>
          )}
          {record?.estado === EstadoInventarioInicial.CERRADO && (
            <Tag color="volcano" icon={<MinusCircleOutlined />}>
              {value}
            </Tag>
          )}
        </>
      ),
    },
    {
      title: "Acciones",
      dataIndex: "acciones",
      key: "acciones",
      render: (value, record) => {
        const existe_detalle_a_procesar =
          record?.detallesinventarioinicial?.some(
            (detalle) => detalle.estado === false,
          );
        const visible_start_process =
          (record?.estado === EstadoInventarioInicial.CONFIRMADO &&
            existe_detalle_a_procesar) ||
          (record?.estado === EstadoInventarioInicial.PROCESADO &&
            existe_detalle_a_procesar);
        const visible_confirmar =
          record?.estado === EstadoInventarioInicial.BORRADOR;
        const visible_eliminar =
          record?.estado === EstadoInventarioInicial.BORRADOR;
        return (
          <>
            <Space wrap>
              <EditDetailBtn onClick={() => handleEditar(record)} />
              {visible_eliminar && (
                <RemoveDetailBtn onClick={() => handleEliminar(record)} />
              )}

              {visible_confirmar && (
                <Tooltip title="Confirmar Inv. Inicial">
                  <Button
                    color="cyan"
                    variant="outlined"
                    onClick={() => handleConfirmar(record)}
                    icon={<CheckCircleOutlined />}
                  />
                </Tooltip>
              )}
              {visible_start_process && (
                <Tooltip title="Procesar Inv. Inicial">
                  <StartBtn
                    onClick={() => handleProcesarInventarioInicial(record)}
                  />
                </Tooltip>
              )}
            </Space>
          </>
        );
      },
    },
  ];
};
export const InventarioInicialTable = ({
  data,
  loading,
  handleOpenForm,
  paginator,
}) => {
  const { modal } = App.useApp();
  const dispatch = useDispatch();
  const handleLoadData = (page = 1, page_size = 10) => {
    let searchFormData = JSON.parse(localStorage.getItem("SearhFormTable"));
    searchFormData = { ...searchFormData, page, page_size };
    dispatch(inventarioInicialStartLoad(searchFormData));
  };
  const handleEditar = (record) => {
    dispatch(inventarioInicialSetActive(record));
    handleOpenForm();
  };
  const handleEliminar = (record) => {
    ShowDeleteConfirm({
      modal,
      title: "¿Está seguro de eliminar el inventario inicial seleccionado?",
      callback: (isConfirmed) => {
        if (isConfirmed) {
          dispatch(inventarioInicialStartDelete(record));
        }
      },
    });
  };
  const handleConfirmar = (record) => {
    // Implementar la lógica para confirmar el inventario inicial
    ShowConfirm({
      modal,
      title: "¿Está seguro de confirmar el inventario inicial seleccionado?",
      callback: (isConfirmed) => {
        if (isConfirmed) {
          // Lógica para confirmar el inventario inicial
          record.estado = EstadoInventarioInicial.CONFIRMADO;
          dispatch(inventarioInicialStartUpdate(record));
        }
      },
    });
  };
  const handleProcesarInventarioInicial = (record) => {
    // Implementar la lógica para procesar el inventario inicial
    ShowConfirm({
      modal,
      title: "¿Está seguro de procesar el inventario inicial seleccionado?",
      callback: (isConfirmed) => {
        if (isConfirmed) {
          // Lógica para procesar el inventario inicial
          dispatch(inventarioInicialStartProcess(record));
        }
      },
    });
  };
  return (
    <TableUi
      size="small"
      rowKey="id"
      loading={loading}
      columns={columns({
        handleEliminar,
        handleEditar,
        handleConfirmar,
        handleProcesarInventarioInicial,
      })}
      data={data}
      pagination={{
        align: "start",
        showSizeChanger: true,
        total: paginator?.count,
        onChange: (page, page_size) => handleLoadData(page, page_size),
        showTotal: (total) => `Total ${total} items`,
      }}
    />
  );
};
